import script from "./ImportICSEvents.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportICSEvents.vue?vue&type=script&setup=true&lang=ts"

import "./ImportICSEvents.vue?vue&type=style&index=0&id=5c73e4c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c73e4c0"]])

export default __exports__